import { thumbUrl } from '../lib/imageThumb';

// <img> for a mentor photo that prefers the resized WebP variant and falls back to the
// original on error. Safe to ship before/independent of the resize backfill: if the
// variant doesn't exist yet (or isn't a Firebase URL), onError swaps in the original.
// Use only when `src` is non-null — callers render an initials placeholder otherwise.
export function MentorAvatarImg({ src, alt, px, size = 200, style }: {
  src: string;
  alt: string;
  px: number;            // rendered pixel size
  size?: number;         // which variant to request (200/400/800)
  style?: React.CSSProperties;
}) {
  const initial = thumbUrl(src, size) ?? src;
  return (
    <img
      src={initial}
      data-fallback={src}
      alt={alt}
      width={px}
      height={px}
      loading="lazy"
      onError={(e) => {
        const el = e.currentTarget;
        const fb = el.dataset.fallback;
        if (fb && el.src !== fb) el.src = fb; // variant missing → use the original (once)
      }}
      style={style}
    />
  );
}
